/**
 * GT Announcement bar — Swiper on mobile + tablet; desktop = CSS flex row.
 */
(function () {
  'use strict';

  var SLIDER_MQ = window.matchMedia('(max-width: 989px)');

  /**
   * @param {HTMLElement} root
   */
  function destroySwiper(root) {
    var el = root.querySelector('.gt-announcement-bar__swiper');
    if (el && el.swiper) {
      el.swiper.destroy(true, true);
    }
  }

  /**
   * @param {HTMLElement} root
   */
  function initSwiper(root) {
    if (!root || typeof window.Swiper !== 'function') return;

    var el = root.querySelector('.gt-announcement-bar__swiper');
    if (!el) return;

    destroySwiper(root);

    if (!SLIDER_MQ.matches) return;

    var slides = el.querySelectorAll('.swiper-slide');
    var count = slides.length;
    if (count === 0) return;

    var loop = count > 1;

    /** @type Record<string, unknown> */
    var params = {
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: true,
      loop: loop,
      allowTouchMove: loop,
      observer: true,
      observeParents: true,
      autoplay: loop
        ? {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false,
    };

    // eslint-disable-next-line no-undef
    new Swiper(el, params);
  }

  /**
   * @param {HTMLElement} root
   */
  function syncSwiper(root) {
    root.classList.toggle('gt-announcement-bar--static', !SLIDER_MQ.matches);

    if (SLIDER_MQ.matches) {
      initSwiper(root);
    } else {
      destroySwiper(root);
    }
  }

  /**
   * @param {HTMLElement} root
   */
  function bindRoot(root) {
    if (!root || root.dataset.gtAnnouncementBarBound === 'true') return;
    root.dataset.gtAnnouncementBarBound = 'true';

    var onChange = function () {
      syncSwiper(root);
    };

    if (typeof SLIDER_MQ.addEventListener === 'function') {
      SLIDER_MQ.addEventListener('change', onChange);
    } else if (typeof SLIDER_MQ.addListener === 'function') {
      SLIDER_MQ.addListener(onChange);
    }

    syncSwiper(root);
  }

  function initAll() {
    document.querySelectorAll('[data-gt-announcement-bar]').forEach(bindRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var target = ev.target;
    if (!target || !target.querySelector) return;
    var root = target.querySelector('[data-gt-announcement-bar]');
    if (root) {
      root.dataset.gtAnnouncementBarBound = '';
      bindRoot(root);
    }
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    var target = ev.target;
    if (!target || !target.querySelector) return;
    var root = target.querySelector('[data-gt-announcement-bar]');
    if (root) destroySwiper(root);
  });
})();
